"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationsPageType = exports.StaffStatus = exports.UserStatus = void 0;
var UserStatus;
(function (UserStatus) {
    UserStatus["INVITE_SENT"] = "INVITE_SENT";
    UserStatus["ACTIVE"] = "ACTIVE";
    UserStatus["INACTIVE"] = "INACTIVE";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
var StaffStatus;
(function (StaffStatus) {
    StaffStatus["ACTIVE"] = "ACTIVE";
    StaffStatus["INACTIVE"] = "INACTIVE";
})(StaffStatus = exports.StaffStatus || (exports.StaffStatus = {}));
var ConfirmationsPageType;
(function (ConfirmationsPageType) {
    ConfirmationsPageType["OUR_PAGE"] = "OUR_PAGE";
    ConfirmationsPageType["REDIRECT"] = "REDIRECT";
})(ConfirmationsPageType = exports.ConfirmationsPageType || (exports.ConfirmationsPageType = {}));
